import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    CustomerProfileUsersService
} from "../../../modules/customers/shared/api/service/customer-profile-users.service";
import {ProfileRoleFull} from "../../api/entity/profile.users";

const DETAILS_SHOW_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.SHOW_ROLE_ACCOUNT_DETAILS';
const DETAILS_HIDE_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.HIDE_ROLE_ACCOUNT_DETAILS';

@Component({
    selector: 'tfl-profile-user-role-details',
    template: require('./profile-user-role.details.template.html')
})
export class ProfileUserRoleDetailsComponent implements OnInit {

    @Input('profile-id') profileId: number;
    @Input('profile-user-role-id') profileUserRoleId: number;
    @Input('profile-user-id') profileUserId: number;
    @Output() ownRoleCreated = new EventEmitter<void>();

    profileUserRole: ProfileRoleFull;
    loadError: string = null;
    showAccountsTable: any | null = null;
    associatedAccountsCount: number = 0;

    constructor(private _customerProfileUsersService: CustomerProfileUsersService) {
    }

    ngOnInit(): void {
        this.showDetails();
    }

    showDetails(): void {
        this.loadError = null;
        this._customerProfileUsersService.getProfileUserRoleDetail(this.profileUserRoleId)
            .subscribe(
                profileUserRole => {
                    this.profileUserRole = profileUserRole;
                    // The admin role sees every account even without links: the table shows the real number
                    this.associatedAccountsCount = (profileUserRole.accounts || []).length;
                },
                error => this.loadError = (error && error.message) || 'Error'
            );
    }

    toggleAccountsTable(profileUserRole: any): void {
        if (this.showAccountsTable && this.showAccountsTable.id === profileUserRole.id) {
            this.showAccountsTable.showDetails = !this.showAccountsTable.showDetails;
        } else {
            if (this.showAccountsTable) {
                this.showAccountsTable.showDetails = false;
            }
            profileUserRole.showDetails = true;
            this.showAccountsTable = profileUserRole;
        }
    }

    getActionProfileUserRoleAccountDetailText(showDetails: boolean): string {
        return showDetails ? DETAILS_HIDE_KEY : DETAILS_SHOW_KEY;
    }

    get roleUserNames(): string {
        return ((this.profileUserRole && this.profileUserRole.users) || []).map(user => user.userName).join(', ');
    }

    updateAssociatedAccountsCount(count: number): void {
        this.associatedAccountsCount = count;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/profile-user/profile-user-role-details/profile-user-role.details.component.ts